import React from 'react';

import { getLanguageConfig } from '../../config/text';

import { Emoji } from '../Emoji';

import './style.scss';

interface Props {
  title: string;
  ingress?: string;
  emoji?: string;
  emojiLabel?: string;
}

export const CardHeader = ({ title, ingress, emoji, emojiLabel }: Props) => {
  const ingressWithHtml = (ingress: string) => {
    return { __html: ingress };
  };

  const textConfig = getLanguageConfig();
  const { altiboxUrl, logoAlt } = textConfig.cardHeader;

  return (
    <div className="card__card-header">
      <a href={altiboxUrl}>
        <img
          className="card__card-header__logo"
          src="https://www.altibox.no/wp-content/uploads/2019/08/altibox-pillelogo-2019.svg"
          alt={logoAlt}
          height="32"
          width="84"
        />
      </a>
      <h1 className="card__card-header__title">{title}</h1>
      {emoji && emojiLabel && <Emoji emoji={emoji} label={emojiLabel} />}
      {ingress && <p className="card__card-header__ingress" dangerouslySetInnerHTML={ingressWithHtml(ingress)} />}
    </div>
  );
};
